import { Overlay } from "@angular/cdk/overlay";
import { MatDialogConfig } from "@angular/material/dialog";

/** Keeps the page layout unchanged behind the dialog (pure overlay, no clipping). */
export function withOverlayOnlyScrollStrategy<T>(
  overlay: Overlay,
  config: MatDialogConfig<T>,
): MatDialogConfig<T> {
  return {
    ...config,
    scrollStrategy: overlay.scrollStrategies.noop(),
  };
}
